import { CpsToast } from "corpus";
import { useRouteContext } from "@tanstack/react-router";
import { useState } from "react";
import { Share as CapacitorShare } from "@capacitor/share";
import {
  PhoneNumberCardRoot,
  AssistProPhoneCardHeader,
  PhoneNumberPendingHeader,
  PhoneNumberSection,
  PhoneNumberPendingSection,
} from "@/components/phone-number-card";
import { trackEvent } from "@/lib/tracking";

export const SubscribedAssistProPhoneNumberCard = (): JSX.Element | null => {
  const { user } = useRouteContext({ strict: false });
  const [openCopiedLinkToast, setOpenCopiedLinkToast] = useState(false);

  const hasPatientPhoneNumber = Boolean(user.ramalTroncoNormalizado);

  const onClickToSharePhoneNumber = async (): Promise<void> => {
    if (!user.ramalTroncoNormalizado) return;

    trackEvent("Numero Compartilhado Assist Pro");

    const canShare = await CapacitorShare.canShare();
    if (!canShare.value) {
      await navigator.clipboard.writeText(user.ramalTroncoNormalizado ?? "");
      setOpenCopiedLinkToast(true);

      return;
    }

    await CapacitorShare.share({
      title: "Aqui está meu número exclusivo para contato!",
      text: user.ramalTroncoNormalizado,
    });
  };

  return hasPatientPhoneNumber ? (
    <>
      <PhoneNumberCardRoot>
        <AssistProPhoneCardHeader />
        <PhoneNumberSection
          ramalTroncoNormalizado={user.ramalTroncoNormalizado ?? ""}
          onShare={() => void onClickToSharePhoneNumber()}
        />
      </PhoneNumberCardRoot>
      <CpsToast
        title="Número de telefone copiado para a área de transferência"
        show={openCopiedLinkToast}
        onClose={() => setOpenCopiedLinkToast(false)}
        type="success"
        duration={5}
      />
    </>
  ) : (
    <PhoneNumberCardRoot>
      <PhoneNumberPendingHeader />
      <PhoneNumberPendingSection />
    </PhoneNumberCardRoot>
  );
};
